/* Publish by EComposer at 2026-10-01 13:14:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kiox81vcae"]=  window.__ectimmers["ecom-kiox81vcae"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-kiox81vcae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kiox81vcae', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjxvsooqhxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjxvsooqhxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bubryzf56fw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bubryzf56fw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oi7fskt3brc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oi7fskt3brc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sr4kowrqgu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sr4kowrqgu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20xeljjga3ej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20xeljjga3ej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kdx123drto').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdx123drto', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z531nbly15e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z531nbly15e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kk41oeertf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kk41oeertf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypqgy8895mf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypqgy8895mf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ojb3gjjomn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ojb3gjjomn', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ka3hec32jd8"]=  window.__ectimmers["ecom-ka3hec32jd8"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),o=this.settings.action;function n(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var m;(m=d.ec_splide)==null||m.refresh()})},50),r())}e.forEach((a,l)=>{o==="click"||window.screen.width<1025?a.onclick=()=>n(a,l):a.onmouseover=()=>n(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let g=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,g)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-ka3hec32jd8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ka3hec32jd8', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}